export namespace Constants {
    export namespace EmpresaServicios {
        export const ID_ENDESA_REAL_ESTATE: string = "4a63fd57-3d2b-4d94-bbe2-2a0b60428b01";
        export const ID_ENDESA_LEAD_WEB: string = "a05dd2e2-22d1-47e8-a488-9d088032a528";
        export const ID_ENDESA_PPNN_Y_CCPP: string = "f1f70000-0430-9600-1112-08de9e561541";
        export const ID_ENDESA_DOMESTICO = "7660e693-5cc4-46b3-be90-ea0587a54e81";
        export const ID_REPSOL_VENTA_TELEFONICA: string = "15870000-0430-9600-0f8b-08ddf7a3181f";
        export const ID_REPSOL: string = "c0970000-038f-9600-22ea-08dd51f96b05";
        export const ID_VISALIA: string = "c0970000-038f-9600-8deb-08dd51f85449";
        export const ID_NOBE: string = "cb740000-0430-9600-11bd-08df1a4b0155";

        export const EMPRESAS_ENDESA: string[] = [ID_ENDESA_REAL_ESTATE, ID_ENDESA_LEAD_WEB, ID_ENDESA_PPNN_Y_CCPP, ID_ENDESA_DOMESTICO];
    
        export const EMPRESAS_CON_FIRMA_DIGITAL: string[] = [ID_ENDESA_REAL_ESTATE, ID_ENDESA_LEAD_WEB, ID_ENDESA_DOMESTICO, ID_NOBE];

        export const EMPRESAS_CON_FIRMA_HIBRIDA: string[] = [ID_ENDESA_PPNN_Y_CCPP];

        export const EMPRESAS_CON_FLUJO_CONTRATO_Y_FIRMA: string[] = [
            ...EMPRESAS_CON_FIRMA_DIGITAL,
            ...EMPRESAS_CON_FIRMA_HIBRIDA,
        ];

        export const EMPRESAS_CON_ANEXO_PLANTILLA: string[] = [ID_ENDESA_LEAD_WEB, ID_ENDESA_DOMESTICO];
    }
}
